<script>
import cartItem from '@/modules/mixins/cartItem'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import { mapGetters } from 'vuex'

export default {
    name: 'CartItem',

    components: { ButtonLoader },

    mixins: [cartItem],

    props: {
        currency: {
            type: Object,
            default: () => {},
        },
        loading: Boolean,
        disabled: Boolean,
    },

    computed: {
        ...mapGetters(['smDevice']),
    },

    methods: {
        removeItem() {
            this.$emit('remove')
        },
    },
}
</script>

<template lang="pug">
.cart-item.py-5.py-lg-3(v-if="value.meal" :class="{'align-items-center bg-white px-5': smDevice}")
    .d-flex.gap-4.w-100.align-items-center.justify-content-between
        div
            h3.d-flex.mb-0(:inner-html.prop="value.name")
            .d-flex.flex-wrap
                template(v-for="(optionGroup, optionGroupIndex) in sortedOptions")
                    .d-inline-flex.justify-content-start.align-items-center(
                        v-for="(option, optionIndex) in optionGroup"
                        :class="{'line-1': smDevice}"
                        :key="`orderExtra-${optionGroupIndex}-${optionIndex}`")
                        template(v-if="option.quantity > 1")
                            span.font-size-sm(:class="{'line-1': smDevice}")
                                | {{option.quantity}}
                            icon.ml-1.mr-2.font-size-micro(icon="fa-solid fa-xmark" size="sm" )
                        span.font-size-sm.text-73(
                            :inner-html.prop="`${option.name}${optionIndex + 1 < optionGroup.length || optionGroupIndex + 1 < sortedOptions.length ? '&nbsp;•&nbsp;': ''}`" 
                            :class="{'line-1': smDevice}")
            .d-flex.gap-2.h3.my-0.mt-lg-2.font-weight-normal.line-1(:class="originalPrice !== price ? 'text-primary' : 'text-73'")
                | {{ price | toCurrency(currency.locale, currency.currency_code) }}
                s.line-1.text-73(v-if="originalPrice !== price && currency.currency_code") {{originalPrice | toCurrency(currency.locale, currency.currency_code)}}
    
        
        button-loader.btn.btn-secondary.btn-icon.btn-round(@click="removeItem" :loading="loading" :disabled="disabled")
            icon(icon="fa-solid fa-trash" size="sm")

</template>
